import { render, staticRenderFns } from "./ModalEscolhaAssinantes.vue?vue&type=template&id=77c520ca&scoped=true"
import script from "./ModalEscolhaAssinantes.vue?vue&type=script&lang=js"
export * from "./ModalEscolhaAssinantes.vue?vue&type=script&lang=js"
import style0 from "./ModalEscolhaAssinantes.vue?vue&type=style&index=0&id=77c520ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c520ca",
  null
  
)

export default component.exports